import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface FilterSelectProps {
  value: number | null;
  onChange: (value: number | null) => void;
  options: { id: number; label: string }[];
  placeholder: string;
}

export function FilterSelect({
  value,
  onChange,
  options,
  placeholder,
}: FilterSelectProps) {
  return (
    <Select
      value={value === null ? 'all' : String(value)}
      onValueChange={(v) => onChange(v === 'all' ? null : Number(v))}
    >
      <SelectTrigger className="w-64">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{placeholder}</SelectItem>
        {options.map((o) => (
          <SelectItem key={o.id} value={String(o.id)}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
